import { authorizedApi } from './index';

export const placesApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPlaces: builder.query({
      query: (input) => ({
        url: '/places/search',
        method: 'GET',
        params: {
          input,
        },
      }),
    }),
  }),
});

export const { useSearchPlacesQuery, useLazySearchPlacesQuery } = placesApi;
